import React, { useState, useEffect } from 'react';
import NewNavbar from './Navbar';

function Contact() {
  const [ContactH1, setContactH1] = useState("");
  const [Address, setAddress] = useState("");
  const [Phone, setPhone] = useState("");
  const [GoogleMapAPI, setGoogleMapAPI] = useState("");
  // Fetch data from Google Sheets
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => {
        setContactH1(data.ContactH1);
        setAddress(data.Address);
        setPhone(data.Phone);
        setGoogleMapAPI(data.GoogleMapAPI);

      })
      .catch(error => console.error('Error loading config:', error));
  }, []);

  return (
    <div>
      <NewNavbar />  
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>{ContactH1}</h1>
        <p>{Address}</p>
        <p>Phone: <a href={`tel:+1${Phone}`}>{Phone}</a></p>

        {/* Google Map Embed */}
        <div style={{ margin: '20px auto', maxWidth: '600px' }}>
          <iframe
            src={GoogleMapAPI}
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Barbershop Location"
          ></iframe>
        </div>

        {/* Social Media Icons */}
        <div style={{ marginTop: '20px' }}>
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" style={{ margin: '0 10px' }}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook" style={{ width: '40px' }} />
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" style={{ margin: '0 10px' }}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: '40px' }} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
